/* 🤖 this file was generated by svg-to-ts */
export const siriusSmalldotsThreeHorisontal: {
  name: 'smalldots_three_horisontal';
  data: string;
} = {
  name: 'smalldots_three_horisontal',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="display: block;"><path d="M12 14.25a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5ZM4.5 14.25a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5ZM19.5 14.25a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5Z" fill="currentColor"/></svg>`
};
